module.exports = __webpack_public_path__ + "img/icon-mail.c9854b95.svg";